<footer class="fixed-footer text-right" style="position:fixed; bottom:10px; right:5px;">
</footer>